import React from 'react';

import SurfaceScope from '../security/SurfaceScope';
import { useSaasVendor } from '../../contexts/SaasVendorContext';

/**
 * Mounts the shared Atlas security workspace inside AI Providers and narrows
 * every security request to the provider selected in the module toolbar.
 *
 * The vendor lives in the URL-backed SaasVendorContext, so changing from
 * Anthropic to OpenAI updates both the visible provider and the API scope
 * without maintaining a second provider switcher in the security pages.
 */
export default function SaasSecurityScope() {
  const { vendor } = useSaasVendor();

  // The security plane names a provider as the vendor key (`google_antigravity`); Agent Atlas by
  // its surface id, hyphenated (`google-antigravity`).
  return (
    <SurfaceScope
      key={vendor}
      surface={vendor}
      atlasSurface={vendor ? String(vendor).replace(/_/g, '-') : null}
      emptyOnUnavailable
    />
  );
}
